interface Props {
    height: number;
}

export const FlagSk = (props: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ height: props.height + 'px' }}
            viewBox="0 0 10800 7200"
            fill="#ee1c25"
        >
            <title>Flag of Slovakia</title>
            <defs>
                <clipPath id="c">
                    <path
                        id="s"
                        d="m4678 1746c0 0 56 561 56 1683-8 1146-865 1726-1494 2031-629-305-1486-885-1494-2031 0-1122 56-1683 56-1683z"
                    />
                </clipPath>
            </defs>
            <g transform="scale(1200)">
                <path fill="#fff" d="m0 0h9v6H0z" />
                <path fill="#0b4ea2" d="m0 2h9v4H0z" />
                <path d="m0 4h9v2H0z" />
            </g>
            <use xlinkHref="#s" />
            <path
                fill="#fff"
                d="m3113 4800V3397c-475 0-610 42-752 85a2323 2323 0 0 0 0-431c142 43 277 85 752 85v-390c-150 0-357 6-595 87a2323 2323 0 0 0 0-432c238 80 445 86 595 86 0-113-35-356-79-557a2323 2323 0 0 0 412 0c-44 201-79 444-79 557 150 0 357-6 595-86a2323 2323 0 0 0 0 432c-238-81-445-87-595-87v390c475 0 610-42 752-85a2323 2323 0 0 0 0 431c-142-43-277-85-752-85v1403z"
            />
            <path
                clipPath="url(#c)"
                fill="#0b4ea2"
                d="m2463 5903a507 867 0 1 1 319-1541 584 1084 0 0 1 916 0 507 867 0 1 1 319 1541z"
            />
            <use xlinkHref="#s" fill="none" stroke="#fff" strokeWidth="108" />
        </svg>
    );
};
